import classNames from 'classnames';
import React, { ReactElement } from 'react';
import './badge.scss';

export type BadgeProps = {
    className?: string;
    color?: 'default' | 'green' | 'purple' | 'yellow' | 'light-blue' | 'light-green' | 'dark-blue' | 'light-orange' | 'grey' | 'red';
    weight?: '500' | '600';
    borderRadius?: 'full' | 'opposite';
    filled?: boolean;
    backgroundColor?: string;
    textColor?: string;
    children: React.ReactNode;
};

const Badge: React.FC<BadgeProps> = ({
    className,
    color = 'default',
    children,
    weight = '500',
    borderRadius = 'full',
    filled = true,
    backgroundColor,
    textColor
}): ReactElement => (
    <span
        style={(backgroundColor && textColor) ? { backgroundColor, borderColor: backgroundColor, color: textColor } : void 0}
        className={classNames({
            [`badge--${color}`]: true,
            [`badge--${color}--filled`]: filled,
            [className || '']: className,
            [`badge--${borderRadius}`]: true,
            [`badge--fw-${weight}`]: true,
            badge: true
        })}
    >
        {children}
    </span>
);

export default Badge;
